<template>
  <div class="container">
    <ul class="list">
      <li class="item">
        <div
          class="header"
          :style="{
            'background-image': `url(${require('assets/images/bg-circle.png')})`
          }"
        >
          原辅料流入
        </div>
        <div class="body">
          <div class="search">
            <el-form>
              <el-row>
                <el-col :span="5">
                  <el-form-item label="原辅料名称" label-width="90px">
                    <el-input
                      placeholder="请输入原辅料名称"
                      v-model="rawAccessoryQueryParams.materielName"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5" :offset="1">
                  <el-form-item label="来源省份" label-width="80px">
                    <el-select
                      placeholder="请选择来源省份"
                      v-model="rawAccessoryQueryParams.regionCode"
                    >
                      <el-option label="全部" value="" />
                      <el-option
                        v-for="item in provinceList"
                        :key="item.id"
                        :label="item.short_name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item>
                    <el-button
                      type="primary"
                      style="margin-left:20px"
                      @click="initRawAccessoryLoad(1)"
                      >查询</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="result">
            <div class="charts">
              <div class="title">
                <p class="text">原辅料流入统计</p>
                <p class="sub-text">原辅料名称数量</p>
              </div>
              <div class="statics-number">
                <div class="statics-item">
                  <div class="num">{{ rawAccessorySupplierNum }}</div>
                  <div class="num-text">供应商数量</div>
                </div>
                <div class="statics-item">
                  <div class="num">{{ rawAccessoryMaterielNum }}</div>
                  <div class="num-text">原辅料名称数量</div>
                </div>
                <div class="statics-item">
                  <div class="num">{{ rawAccessoryProvinceNum }}</div>
                  <div class="num-text">来源省份数量</div>
                </div>
              </div>
              <Echarts :echartsOption="echartsOption1" />
            </div>
            <div class="content-list">
              <div class="title">
                <p class="text">原辅料流入列表</p>
                <p class="sub-text">原辅料名称</p>
              </div>
              <div class="table-list">
                <el-table :data="rawAccessoryList">
                  <el-table-column
                    label="原辅料名称"
                    prop="materiel_name"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    label="来源省份"
                    prop="short_name"
                    width="100px"
                  />
                  <el-table-column
                    label="供应商名称"
                    prop="supplier_name"
                    show-overflow-tooltip
                  />
                </el-table>
              </div>
              <el-pagination
                class="pagination"
                layout="total, prev, pager, next, jumper"
                :total="rawAccessoryTotal"
                :current-page="rawAccessoryCurrentPage"
                :page-size="6"
                @current-change="loadRawAccessoryList"
              />
            </div>
            <div class="border"></div>
          </div>
        </div>
      </li>
      <li class="item">
        <div
          class="header"
          :style="{
            'background-image': `url(${require('assets/images/bg-squre.png')})`
          }"
        >
          药品流入
        </div>
        <div class="body">
          <div class="search">
            <el-form>
              <el-row>
                <el-col :span="5">
                  <el-form-item label="药品通用名称" label-width="100px">
                    <el-input
                      placeholder="请输入药品通用名称"
                      v-model="drugInQueryParams.productName"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5" :offset="1">
                  <el-form-item label="药品批准文号" label-width="100px">
                    <el-input
                      placeholder="请输入药品批准文号"
                      v-model="drugInQueryParams.approvalNumber"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5" :offset="1">
                  <el-form-item label="来源省份" label-width="80px">
                    <el-select
                      placeholder="请选择来源省份"
                      v-model="drugInQueryParams.regionCode"
                    >
                      <el-option label="全部" value="" />
                      <el-option
                        v-for="item in provinceList"
                        :key="item.id"
                        :label="item.short_name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item>
                    <el-button
                      type="primary"
                      style="margin-left:20px"
                      @click="initDrugInLoad(1)"
                      >查询</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="result">
            <div class="charts">
              <div class="title">
                <p class="text">药品流入统计</p>
                <p class="sub-text">药品批准文号数量</p>
              </div>
              <div class="statics-number">
                <div class="statics-item">
                  <div class="num">{{ drugInEntNum }}</div>
                  <div class="num-text">生产企业数量</div>
                </div>
                <div class="statics-item">
                  <div class="num">{{ drugInApprovalNum }}</div>
                  <div class="num-text">药品批准文号数量</div>
                </div>
                <div class="statics-item">
                  <div class="num">{{ drugInProvinceNum }}</div>
                  <div class="num-text">来源省份数量</div>
                </div>
              </div>
              <Echarts :echartsOption="drugInOption" />
            </div>
            <div class="content-list">
              <div class="title">
                <p class="text">药品流入列表</p>
                <p class="sub-text">药品批准文号</p>
              </div>
              <div class="table-list">
                <el-table :data="drugInList">
                  <el-table-column
                    label="药品通用名称"
                    prop="product_name"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    label="药品批准文号"
                    prop="approval_number"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    label="来源省份"
                    prop="short_name"
                    width="160px"
                  />
                  <el-table-column
                    label="生产企业名称"
                    prop="product_ent_name"
                    show-overflow-tooltip
                  />
                </el-table>
              </div>
              <el-pagination
                class="pagination"
                layout="total, prev, pager, next, jumper"
                :total="drugInTotal"
                :current-page="drugInCurrentPage"
                :page-size="6"
                @current-change="
                  currentPage => {
                    loadDrugList('In', currentPage);
                  }
                "
              />
            </div>
            <div class="border"></div>
          </div>
        </div>
      </li>
      <li class="item">
        <div
          class="header"
          :style="{
            'background-image': `url(${require('assets/images/bg-rectangle.png')})`
          }"
        >
          药品流出
        </div>
        <div class="body">
          <div class="search">
            <el-form>
              <el-row>
                <el-col :span="5">
                  <el-form-item label="药品通用名称" label-width="100px">
                    <el-input
                      placeholder="请输入药品通用名称"
                      v-model="drugOutQueryParams.productName"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5" :offset="1">
                  <el-form-item label="药品批准文号" label-width="100px">
                    <el-input
                      placeholder="请输入药品批准文号"
                      v-model="drugOutQueryParams.approvalNumber"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5" :offset="1">
                  <el-form-item label="去向省份" label-width="80px">
                    <el-select
                      placeholder="请选择去向省份"
                      v-model="drugOutQueryParams.regionCode"
                    >
                      <el-option label="全部" value="" />
                      <el-option
                        v-for="item in provinceList"
                        :key="item.id"
                        :label="item.short_name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item>
                    <el-button
                      type="primary"
                      style="margin-left:20px"
                      @click="initDrugOutLoad(1)"
                      >查询</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="result">
            <div class="charts">
              <div class="title">
                <p class="text">药品流出统计</p>
                <p class="sub-text">药品批准文号数量</p>
              </div>
              <div class="statics-number">
                <div class="statics-item">
                  <div class="num">{{ drugOutEntNum }}</div>
                  <div class="num-text">生产企业数量</div>
                </div>
                <div class="statics-item">
                  <div class="num">{{ drugOutApprovalNum }}</div>
                  <div class="num-text">药品批准文号数量</div>
                </div>
                <div class="statics-item">
                  <div class="num">{{ drugOutProvinceNum }}</div>
                  <div class="num-text">去向省份数量</div>
                </div>
              </div>
              <Echarts :echartsOption="drugOutOption" />
            </div>
            <div class="content-list">
              <div class="title">
                <p class="text">药品流出列表</p>
                <p class="sub-text">药品批准文号</p>
              </div>
              <div class="table-list">
                <el-table :data="drugOutList">
                  <el-table-column
                    label="药品通用名称"
                    prop="product_name"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    label="药品批准文号"
                    prop="approval_number"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    label="去向省份"
                    prop="short_name"
                    width="160px"
                  />
                  <el-table-column
                    label="生产企业名称"
                    prop="product_ent_name"
                    show-overflow-tooltip
                  />
                </el-table>
              </div>
              <el-pagination
                class="pagination"
                layout="total, prev, pager, next, jumper"
                :total="drugOutTotal"
                :current-page="drugOutCurrentPage"
                :page-size="6"
                @current-change="
                  currentPage => {
                    loadDrugList('Out', currentPage);
                  }
                "
              />
            </div>
            <div class="border"></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Echarts from 'components/echarts/echarts';

export default {
  data() {
    return {
      rawAccessoryQueryParams: {
        materielName: '',
        regionCode: ''
      },
      rawAccessorySupplierNum: '',
      rawAccessoryMaterielNum: '',
      rawAccessoryProvinceNum: '',
      echartsOption1: {
        grid: {
          top: '26px'
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424',
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        series: [
          {
            data: [],
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            }
          }
        ]
      },
      rawAccessoryList: [],
      rawAccessoryTotal: 0,
      rawAccessoryCurrentPage: 1,
      drugInQueryParams: {
        approvalNumber: '',
        productName: '',
        regionCode: ''
      },
      drugInEntNum: '',
      drugInApprovalNum: '',
      drugInProvinceNum: '',
      drugInOption: {
        grid: {
          top: '26px'
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424',
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        series: [
          {
            data: [36, 87, 45, 43, 28, 68, 220, 131],
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            }
          }
        ]
      },
      drugInList: [],
      drugInTotal: 0,
      drugInCurrentPage: 1,
      drugOutQueryParams: {
        approvalNumber: '',
        productName: '',
        regionCode: ''
      },
      drugOutEntNum: '',
      drugOutApprovalNum: '',
      drugOutProvinceNum: '',
      drugOutOption: {
        grid: {
          top: '26px'
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424',
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        series: [
          {
            data: [68, 90, 75, 140, 125, 100, 40, 118],
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            }
          }
        ]
      },
      drugOutList: [],
      drugOutTotal: 0,
      drugOutCurrentPage: 1
    };
  },
  computed: {
    ...mapState(['provinceList'])
  },
  mounted() {
    this.initRawAccessoryLoad(1);
    this.initDrugInLoad(1);
    this.initDrugOutLoad(1);
  },
  methods: {
    initRawAccessoryLoad(currentChange) {
      this.loadRawAccessoryEcharts();
      this.loadRawAccessoryList(1);
    },
    // 原辅料流入图表
    loadRawAccessoryEcharts() {
      this.$request({
        url: 'rest/circulation/supplierAreaStatics',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 10000
            },
            params: {
              ...this.rawAccessoryQueryParams
            }
          })
        }
      }).then(res => {
        this.rawAccessorySupplierNum = res.supplierNum;
        this.rawAccessoryMaterielNum = res.materielNum;
        this.rawAccessoryProvinceNum = res.provinceNum;
        const xData = [];
        const yData = [];
        res.list.forEach(item => {
          xData.push(item.short_name);
          yData.push(item.materiel_num);
        });
        this.echartsOption1.xAxis.data = xData;
        this.echartsOption1.series[0].data = yData;
      });
    },
    // 原辅料流入列表
    loadRawAccessoryList(currentChange) {
      this.rawAccessoryCurrentPage = currentChange;
      this.$request({
        url: 'open/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.rawAccessoryCurrentPage,
              pageSize: 6
            },
            params: {
              handlerName: 'supplier_province_list',
              ...this.rawAccessoryQueryParams
            }
          })
        }
      }).then(res => {
        this.rawAccessoryTotal = res.total;
        this.rawAccessoryList = res.list;
      });
    },
    initDrugInLoad(currentChange) {
      this.loadDrugEcharts('In');
      this.loadDrugList('In', 1);
    },
    initDrugOutLoad(currentChange) {
      this.loadDrugEcharts('Out');
      this.loadDrugList('Out', 1);
    },
    // 药品流入/流出图表
    loadDrugEcharts(type) {
      let params;
      if (type === 'In') {
        params = {
          ...this.drugInQueryParams,
          tableName: 'buss_drug_income_info'
        };
      } else {
        params = {
          ...this.drugOutQueryParams,
          tableName: 'buss_drug_out_info'
        };
      }
      this.$request({
        url: 'rest/circulation/bussOutInStatics',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 10000
            },
            params
          })
        }
      }).then(res => {
        this[`drug${type}ApprovalNum`] = res.approvalNum;
        this[`drug${type}EntNum`] = res.entNum;
        this[`drug${type}ProvinceNum`] = res.provinceNum;
        const xData = [];
        const yData = [];
        res.list.forEach(item => {
          xData.push(item.short_name);
          yData.push(item.approval_number);
        });
        this[`drug${type}Option`].xAxis.data = xData;
        this[`drug${type}Option`].series[0].data = yData;
      });
    },
    // 药品流入/流出列表
    loadDrugList(type, currentChange) {
      let params;
      if (type === 'In') {
        params = {
          ...this.drugInQueryParams,
          tableName: 'buss_drug_income_info'
        };
      } else {
        params = {
          ...this.drugOutQueryParams,
          tableName: 'buss_drug_out_info'
        };
      }
      this[`drug${type}CurrentPage`] = currentChange;
      this.$request({
        url: 'open/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: currentChange,
              pageSize: 6
            },
            params: {
              ...params,
              handlerName: 'buss_out_list'
            }
          })
        }
      }).then(res => {
        this[`drug${type}Total`] = res.total;
        this[`drug${type}List`] = res.list;
      });
    },
    currentChange(page) {
      this.$emit('currentChange', page);
    },
    handleChange() {
      this.$emit('sourceChange');
    }
  },
  components: {
    Echarts
  }
};
</script>

<style lang="stylus" scoped>
.el-table
  >>>td
    padding 9px 0
.item
  margin-bottom 21px
  .header
    background-size cover
    height 74px
    line-height 60px
    padding-left 21px
    font-size 18px
    border-radius 8px 8px 0 0
  .body
    background #fff
    border-radius 8px
    transform translate(0, -16px)
    overflow hidden
    padding 0 20px
    .title
      border-bottom 1px solid rgba(206, 219, 239, .5)
      padding 12px 0
      .text
        color #000
        font-size 14px
        margin-bottom 6px
      .sub-text
        color #666666
        font-size 12px
      .type
        float right
        margin-top -37px
        width 80px
        height 32px
        margin-right 30px
        >>>.el-input__inner
          height 32px
          line-height 32px
        >>>.el-input__icon
          line-height 32px
    .search
      padding 30px 0
    .result
      height 445px
      position relative
      border-top 1px solid rgba(206, 219, 239, .5)
      .charts
        width 544px
        float left
        .statics-number
          display flex
          justify-content center
          .statics-item
            margin 0 10px
            text-align center
            padding-top 26px
            .num
              color #386CE2
              font-size 20px
              margin-bottom 5px
            .num-text
              color #666666
              font-size 12px
      .content-list
        float left
        width 715px
        position relative
        height 100%
        .title
          padding-left 30px
        .table-list
          margin 20px 20px 20px 30px
        .pagination
          position absolute
          bottom 30px
          right 20px
      .border
        position absolute
        left 544px
        top 0
        bottom 0
        width 1px
        background rgba(206, 219, 239, .5)
</style>
